<template>
  <div>

    <!-- HERO -->
    <div
      class="hero-section"
      :style="{
        backgroundImage:
          informations && informations.header_img
            ? 'url(https://admin.asso-refuge.fr/images/' + informations.header_img + ')'
            : 'none'
      }"
    >
    </div>

    <!-- DERNIERS ARRIVÉS -->
    <div class="adopt-block">
      <div class="adopt-wrap">

        <!-- En-tête -->
        <div class="adopt-head">
          <div class="adopt-head__left">
            <span class="adopt-eyebrow"><i class="fas fa-paw"></i> Adoption</span>
            <h2 class="adopt-title">Nos animaux à adopter</h2>
          </div>
          <router-link to="/animaux" class="adopt-cta">
            Voir tous nos animaux <i class="fas fa-arrow-right"></i>
          </router-link>
        </div>

        <!-- Stats -->
        <div class="adopt-stats">
          <div class="adopt-stat">
            <i class="fas fa-dog adopt-stat__ico"></i>
            <div>
              <strong>{{ chiens.length }}</strong>
              <span>Chiens</span>
            </div>
          </div>
          <div class="adopt-stat">
            <i class="fas fa-cat adopt-stat__ico"></i>
            <div>
              <strong>{{ chats.length }}</strong>
              <span>Chats</span>
            </div>
          </div>
          <div class="adopt-stat">
            <i class="fas fa-heart adopt-stat__ico adopt-stat__ico--red"></i>
            <div>
              <strong>{{ chiens.length + chats.length}}</strong>
              <span>Animaux au total</span>
            </div>
          </div>
       
        </div>

      </div>
      <homeData :chiens="chiens" :chats="chats" />

      <!-- Carousel en dehors du wrap pour garder sa taille d'origine -->

    </div>

    <div id="actuID" class="seperation"></div>

    <!-- ACTUS -->
    <div class="news-block">
      <div class="news-wrap">

        <!-- En-tête -->
        <div class="news-head">
          <div class="news-head__left">
            <span class="news-eyebrow"><i class="fas fa-newspaper"></i> Actualités</span>
            <h2 class="news-title">Les dernières actualités</h2>
          </div>
          <router-link to="/actualites" class="news-cta-link">
            Voir tout <i class="fas fa-arrow-right"></i>
          </router-link>
        </div>

        <!-- Grille d'actus -->
        <div class="news-grid" v-if="news && news.length">

          <!-- Grande carte (1ère actu) -->
          <router-link
            v-if="news[0]"
            :to="'/publication/' + news[0].id"
            class="ncard ncard--big"
            :style="news[0].image ? { backgroundImage: 'url(https://admin.asso-refuge.fr/images/' + news[0].image + ')' } : {}"
          >
            <div class="ncard__shade"></div>
            <div class="ncard__body">
              <span class="ncard__tag">Actu · Refuge</span>
              <p class="ncard__title">{{ news[0].nom }}</p>
              <span class="ncard__read">Lire <i class="fas fa-arrow-right"></i></span>
            </div>
          </router-link>

          <!-- 3 petites cartes -->
          <router-link
            v-for="actu in news.slice(1, 4)"
            :key="actu.id"
            :to="'/publication/' + actu.id"
            class="ncard ncard--small"
            :style="actu.image ? { backgroundImage: 'url(https://admin.asso-refuge.fr/images/' + actu.image + ')' } : {}"
          >
            <div class="ncard__shade"></div>
            <div class="ncard__body">
              <span class="ncard__tag">Actu</span>
              <p class="ncard__title">{{ actu.nom }}</p>
              <span class="ncard__read">Lire <i class="fas fa-arrow-right"></i></span>
            </div>
          </router-link>

        </div>

        <div class="news-empty" v-else>
          <i class="fas fa-newspaper"></i>
          Aucune actualité pour le moment.
        </div>

        <!-- CTA bas -->
        <div class="news-footer">
          <router-link to="/actualites" class="news-cta-wide">
            <i class="fas fa-newspaper"></i>
            Voir toutes nos actualités
          </router-link>
        </div>

      </div>
    </div>

    <div class="seperation"></div>

    <!-- INFORMATIONS -->
    <div class="info-section" id="refuge">
      <div class="info-wrap">
        <h2 class="font-weight-bold mb-4 text-center">Les Informations</h2>

        <div class="info-mosaic">

          <!-- MAP -->
          <div class="icard icard--map">
            <div class="icard__head">
              <div class="icard__icon"><i class="fas fa-map-location-dot"></i></div>
              <span class="icard__label">Carte</span>
            </div>
            <div class="icard__map" v-if="showMap">
              <img
                src=" https://admin.asso-refuge.fr/documents/snipaste-2026-03-08-12-58-18-69ad646cc426f.png"
                alt="Carte du SPA Tarbes | Bigorre - Hautes-Pyrénées"
              />
            </div>
          </div>

          <!-- Email -->
          <div class="icard">
            <div class="icard__head">
              <div class="icard__icon icard__icon--rose"><i class="fas fa-envelope"></i></div>
              <span class="icard__label">Email</span>
            </div>
            <p class="icard__val" v-html="formattedEmail"></p>
          </div>

          <!-- Adresse -->
          <div class="icard">
            <div class="icard__head">
              <div class="icard__icon icard__icon--blue"><i class="fas fa-location-dot"></i></div>
              <span class="icard__label">Adresse</span>
            </div>
            <p class="icard__val" v-html="formattedAdresse"></p>
          </div>

          <!-- Téléphone -->
          <div class="icard">
            <div class="icard__head">
              <div class="icard__icon icard__icon--green"><i class="fas fa-phone"></i></div>
              <span class="icard__label">Téléphone</span>
            </div>
            <p class="icard__val" v-html="formattedPhone"></p>
          </div>

          <!-- Horaires -->
          <div class="icard">
            <div class="icard__head">
              <div class="icard__icon icard__icon--amber"><i class="fas fa-clock"></i></div>
              <span class="icard__label">Horaires</span>
            </div>
            <p class="icard__val" v-html="formattedHorraire"></p>
          </div>

        </div>

        <div class="info-footnote">
          <i class="fas fa-heart"></i>
          Merci de soutenir nos actions — chaque geste compte.
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import homeData from '../components/homeData.vue'
</script>

<script>
export default {
  data() {
    return {
      informations: null,
      news: [],
      animaux: [],
      chats: [],
      chiens: [],
      nacs: [],
      items: [],
      showMap: false
    }
  },

  mounted() {
    const idSite = this.$idSite

    fetch(`https://admin.asso-refuge.fr/getInformations/${idSite}`)
      .then(res => res.json())
      .then(data => {
        if (data && data.length) {
          this.informations = data[0]
        }
      })

    fetch(`https://admin.asso-refuge.fr/getNews/${idSite}`)
      .then(res => res.json())
      .then(data => (this.news = data || []))

    fetch(`https://admin.asso-refuge.fr/getAnimal/${idSite}`)
      .then(res => res.json())
      .then(data => {
        this.animaux = data || []
        this.chats = this.animaux.filter(a => a.type === 'chat')
        this.chiens = this.animaux.filter(a => a.type === 'chien')
        this.nacs = this.animaux.filter(a => a.type === 'nacs')
      })

    // RENDER MAP APRÈS LAYOUT
    this.$nextTick(() => {
      setTimeout(() => {
        this.showMap = true
      }, 150)
    })
  },

  computed: {
    formattedHorraire() {
      return this.informations?.horraire?.replace(/\r\n/g, '<br>') || ''
    },
    formattedEmail() {
      return this.informations?.email?.replace(/\r\n/g, '<br>') || ''
    },
    formattedAdresse() {
      return this.informations?.address?.replace(/\r\n/g, '<br>') || ''
    },
    formattedPhone() {
      return this.informations?.phone?.replace(/\r\n/g, '<br>') || ''
    }
  }
}
</script>

<style scoped>
/* ══════════════════════════════════════
   BLOC ADOPTION
══════════════════════════════════════ */
.adopt-block {
  background: #f7f7f8;
  padding: 48px 0 36px;
}
.adopt-wrap {
  max-width: 75%;
  margin: 0 auto;
  padding: 0 28px;
}

/* En-tête */
.adopt-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.adopt-head__left {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.adopt-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 13px;
  border-radius: 999px;
  background: rgba(203,32,38,.10);
  color: #82a93c;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .04em;
  text-transform: uppercase;
  width: fit-content;
}
.adopt-title {
  margin: 0;
  font-size: clamp(22px, 2.8vw, 34px);
  font-weight: 900;
  letter-spacing: -.025em;
  color: #111;
}

/* CTA */
.adopt-cta {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 11px 18px;
  border-radius: 12px;
  background: #fff;
  border: 1.5px solid #e0e0e0;
  color: #111;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
  transition: border-color .15s, box-shadow .15s;
}
.adopt-cta:hover {
  border-color: #bbb;
  box-shadow: 0 4px 14px rgba(0,0,0,.08);
}

/* Stats */
.adopt-stats {
  display: flex;
  gap: 12px;
  margin-bottom: 4px;
  flex-wrap: wrap;
}
.adopt-stat {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,.06);
  flex: 1;
  min-width: 140px;
}
.adopt-stat__ico {
  font-size: 22px;
  color: #555;
  flex-shrink: 0;
}
.adopt-stat__ico--red   { color: #82a93c; }
.adopt-stat__ico--green { color: #148050; }
.adopt-stat div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.adopt-stat strong {
  font-size: 22px;
  font-weight: 900;
  color: #111;
  line-height: 1;
}
.adopt-stat span {
  font-size: 12px;
  font-weight: 600;
  color: #888;
}

/* ══════════════════════════════════════
   BLOC ACTUALITÉS
══════════════════════════════════════ */
.news-block {
  background: #fff;
  padding: 52px 0 44px;
}
.news-wrap {
  max-width: 75%;
  margin: 0 auto;
  padding: 0 28px;
}

/* En-tête */
.news-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}
.news-head__left {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.news-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 13px;
  border-radius: 999px;
  background: rgba(203,32,38,.10);
  color: #82a93c;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .04em;
  text-transform: uppercase;
  width: fit-content;
}
.news-title {
  margin: 0;
  font-size: clamp(22px, 2.8vw, 34px);
  font-weight: 900;
  letter-spacing: -.025em;
  color: #111;
}
.news-cta-link {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 11px 18px;
  border-radius: 12px;
  background: #f7f7f8;
  border: 1.5px solid #e0e0e0;
  color: #111;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
  transition: border-color .15s, box-shadow .15s;
}
.news-cta-link:hover { border-color: #bbb; box-shadow: 0 4px 14px rgba(0,0,0,.08); }

/* Grille */
.news-grid {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr;
  grid-template-rows: 360px;
  gap: 14px;
}
@media (max-width: 1024px) {
  .news-grid {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 280px 280px;
  }
  .ncard--big { grid-column: span 2; }
}
@media (max-width: 600px) {
  .news-grid {
    grid-template-columns: 1fr;
    grid-template-rows: 260px;
  }
  .ncard--big { grid-column: span 1; }
}

/* Cards */
.ncard {
  position: relative;
  border-radius: 22px;
  overflow: hidden;
  background: #ddd;
  background-size: cover;
  background-position: center;
  text-decoration: none;
  display: flex;
  align-items: flex-end;
  transition: transform .2s, box-shadow .2s;
}
.ncard:hover { transform: translateY(-3px); box-shadow: 0 12px 32px rgba(0,0,0,.14); }

.ncard--small { grid-row: 1; }

.ncard__shade {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0,0,0,.04) 30%, rgba(0,0,0,.72) 100%);
}
.ncard__body {
  position: relative;
  z-index: 2;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.ncard__tag {
  display: inline-flex;
  align-self: flex-start;
  padding: 5px 10px;
  border-radius: 999px;
  background: rgba(255,255,255,.15);
  border: 1px solid rgba(255,255,255,.2);
  backdrop-filter: blur(8px);
  color: rgba(255,255,255,.9);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .03em;
  text-transform: uppercase;
}
.ncard__title {
  margin: 0;
  color: #fff;
  font-weight: 800;
  font-size: 15px;
  line-height: 1.3;
  text-shadow: 0 2px 8px rgba(0,0,0,.3);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.ncard--big .ncard__title { font-size: 20px; }
.ncard__read {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: rgba(255,255,255,.8);
  font-size: 12px;
  font-weight: 800;
}
.ncard:hover .ncard__read { color: #fff; }

/* Empty */
.news-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px 0;
  color: #aaa;
  font-weight: 600;
}

/* Footer */
.news-footer {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}
.news-cta-wide {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 13px 28px;
  border-radius: 14px;
  background: #111;
  color: #fff;
  font-size: 14px;
  font-weight: 900;
  text-decoration: none;
  transition: transform .15s, box-shadow .15s;
}
.news-cta-wide:hover { transform: translateY(-2px); box-shadow: 0 8px 22px rgba(0,0,0,.18); color: #fff; }

/* ── Info section wrapper ── */
.info-section {
  padding: 48px 0 56px;
  background: #f7f7f8;
}
.info-wrap {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ── Mosaic grid ── */
.info-mosaic {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr;
  grid-template-rows: auto auto;
  gap: 16px;
}
.icard--map { grid-row: span 2; }

@media (max-width: 900px) {
  .info-mosaic { grid-template-columns: 1fr 1fr; }
  .icard--map  { grid-column: span 2; grid-row: span 1; }
}
@media (max-width: 560px) {
  .info-mosaic { grid-template-columns: 1fr; }
  .icard--map  { grid-column: span 1; }
}

/* ── Cards ── */
.icard {
  background: #fff;
  border-radius: 22px;
  padding: 22px;
  box-shadow: 0 4px 18px rgba(0,0,0,.07);
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.icard--map {
  padding: 0;
  overflow: hidden;
}

.icard__head {
  display: flex;
  align-items: center;
  gap: 10px;
}
.icard--map .icard__head {
  padding: 22px 22px 0;
}

.icard__icon {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f3;
  font-size: 18px;
  color: #444;
  flex-shrink: 0;
}
.icard__icon--rose  { background: rgba(220,30,100,.10); color: #c0185a; }
.icard__icon--blue  { background: rgba(30,80,220,.10);  color: #1a44c8; }
.icard__icon--green { background: rgba(20,160,80,.10);  color: #148050; }
.icard__icon--amber { background: rgba(220,140,0,.10);  color: #b88000; }

.icard__label {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #aaa;
}

.icard__val {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.75;
  color: #333;
}

/* ── Map image ── */
.icard__map {
  flex: 1;
  min-height: 300px;
  margin-top: 14px;
}
.icard__map img {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 300px;
  object-fit: cover;
}

/* ── Footnote ── */
.info-footnote {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  margin-top: 28px;
  padding: 14px 20px;
  border-radius: 999px;
  background: #fff;
  border: 1.5px solid #e8e8e8;
  font-size: 14px;
  font-weight: 700;
  color: #555;
}
.info-footnote i { color: #e0185a; }
</style>
